import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TaskListStyleConfig } from '../interfaces';

export const DeadlineDateStyles = makeStyles<TaskListStyleConfig>()((theme: Theme, props) => ({
  calenderIcon: {
    fontSize: '1.5rem',
    marginLeft: '0.25rem',
    color: props.labelColor,
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.20rem',
    },
  },
  deadlineDate: {
    letterSpacing: '0.0625rem',
    fontWeight: 'bold',
    lineHeight: 'normal',
    fontSize: 20,
    marginLeft: '0.913rem',
    [theme.breakpoints.down('sm')]: {
      width: '13.75rem',
      height: '2.74rem',
      marginLeft: '0.6125rem',
      fontSize: 16,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '0.7375rem',
      fontSize: 16,
    },
  },
}));
